export const drawCorners = (ctx, x1, y1, width, height, color = 'white') => {
    const cornerLength = 20;
    const lineWidth = Math.max(Math.min(ctx.canvas.width, ctx.canvas.height) / 200, 2.5);

    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;

    // Top-left corner
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x1 + cornerLength, y1);
    ctx.moveTo(x1, y1);
    ctx.lineTo(x1, y1 + cornerLength);
    ctx.stroke();

    // Top-right corner
    ctx.beginPath();
    ctx.moveTo(x1 + width, y1);
    ctx.lineTo(x1 + width - cornerLength, y1);
    ctx.moveTo(x1 + width, y1);
    ctx.lineTo(x1 + width, y1 + cornerLength);
    ctx.stroke();

    // Bottom-left corner
    ctx.beginPath();
    ctx.moveTo(x1, y1 + height);
    ctx.lineTo(x1 + cornerLength, y1 + height);
    ctx.moveTo(x1, y1 + height);
    ctx.lineTo(x1, y1 + height - cornerLength);
    ctx.stroke();

    // Bottom-right corner
    ctx.beginPath();
    ctx.moveTo(x1 + width, y1 + height);
    ctx.lineTo(x1 + width - cornerLength, y1 + height);
    ctx.moveTo(x1 + width, y1 + height);
    ctx.lineTo(x1 + width, y1 + height - cornerLength);
    ctx.stroke();
};

export const clearCanvas = (canvasRef) => {
    if (!canvasRef) return;
    const ctx = canvasRef.getContext("2d");
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
};

export const getFrameBorderPoints = (frameDivRef, canvasRef, canvasWidth = 640, canvasHeight = 640) => {
    if (!frameDivRef || !canvasRef) return null;

    const frameDivRect = frameDivRef.getBoundingClientRect();
    const canvasRect = canvasRef.getBoundingClientRect();
    const canvasWidthRatio = canvasWidth / canvasRect.width;
    const canvasHeightRatio = canvasHeight / canvasRect.height;

    return {
        x1: (frameDivRect.x - canvasRect.x) * canvasWidthRatio,
        y1: (frameDivRect.y - canvasRect.y) * canvasHeightRatio,
        x2: ((frameDivRect.x - canvasRect.x) + frameDivRect.width) * canvasWidthRatio,
        y2: ((frameDivRect.y - canvasRect.y) + frameDivRect.height) * canvasHeightRatio
    };
};

